module.exports = __webpack_public_path__ + "img/jiaju.d143e3e3.png";